import { provideAppInitializer, inject } from '@angular/core';
import { environment } from '../environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom, take } from 'rxjs';
import { ViewportScroller } from '@angular/common';
import { AnchorOffsetService } from './anchor-offset.service';
import { DeviceService } from './device.service';

/**
 * Initializes theme and translations based on the app mode.
 */
export const appInitializer = provideAppInitializer(() => {
  const translateService = inject(TranslateService);
  const deviceService = inject(DeviceService);

  if(deviceService.isIosBrowser) {
    // anchor scroll workaround for ios to include top safezone
    const scroller: ViewportScroller = inject(ViewportScroller);
    const anchorOffset: AnchorOffsetService = inject(AnchorOffsetService);
    scroller.setOffset(() => [0, anchorOffset.getTopOffset()]);
  }

  const language = environment.appBuildModeLanguage;
  const mode = environment.appBuildMode;

  if (!language) {
    console.error('No provided language!');
    return;
  }

  if (!mode) {
    console.error('Probably did not build app with a specified mode (bwm/liberro).');
    return;
  }

  translateService.addLangs([language]);
  translateService.setFallbackLang(language);


  return Promise.all([
    // subscribe to onLangChange if needing to react to translations completition
    firstValueFrom(translateService.use(language).pipe(take(1)))
  ]);

});
